import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledContent,
  StyledImage
} from './StackOverflowWarranties.styled';

const StackOverflowWarranties: React.FC = (): JSX.Element => {
  const { t } = useI18n('stackOverflowLanding');
  return (
    <StyledContainer>
      <StyledImage>
        <img src={getPublicPath('/images/sOLanding/console.gif')} alt="" />
      </StyledImage>
      <StyledContent>
        <Heading2 editorial>{t('warranties.title')}</Heading2>

        <p>{t('warranties.description')}</p>
        <ul>
          <li>
            <Trans
              ns={'stackOverflowLanding'}
              i18nKey={'warranties.list.listItem1'}
              components={{
                scraper: (
                  <a
                    href="https://github.com/getmanfred/dev-story-scraper"
                    target="_blank"
                    rel="noreferrer"
                  ></a>
                ),
                strong: <strong />
              }}
            ></Trans>
          </li>
          <li>
            <Trans
              ns={'stackOverflowLanding'}
              i18nKey={'warranties.list.listItem2'}
              components={{
                scraper: (
                  <a
                    href="https://github.com/getmanfred/mac"
                    target="_blank"
                    rel="noreferrer"
                  ></a>
                ),
                strong: <strong />
              }}
            ></Trans>
          </li>
        </ul>
      </StyledContent>
    </StyledContainer>
  );
};

export default StackOverflowWarranties;
